import { render, staticRenderFns } from "./ContentExample.vue?vue&type=template&id=0cefa1e2&"
import script from "./ContentExample.vue?vue&type=script&lang=js&"
export * from "./ContentExample.vue?vue&type=script&lang=js&"
import style0 from "./ContentExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports